import styled from 'styled-components';
import { PaginatorStyled } from '../PaginatorStyled';

export const PaginatorStyledAP = styled(PaginatorStyled)``;
